import {useMutation} from '@tanstack/react-query';

import type {PostCheckoutRecurrenceParams} from 'domain/usecases';

import {postCheckoutRecurrence} from '../../services/postCheckoutRecurrence';

export const usePostCheckoutRecurrenceMutation = () =>
	useMutation({
		mutationFn: (params: Omit<PostCheckoutRecurrenceParams, 'signal'>) =>
			postCheckoutRecurrence(params),
		retry: 0,
	});
